module.exports = __webpack_public_path__ + "static/media/vignan_short_logo.7984b4d8.png";